import { parseISO } from 'date-fns';
import SuperJSON from 'superjson';
SuperJSON.registerCustom({
    isApplicable: (v) => v instanceof Date,
    serialize: (v) => v.toJSON().replace(/Z$/, ''),
    deserialize: (v) => parseISO(v),
}, 'JUCY.Date');
export const serializer = SuperJSON;
